import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types';
import { ChatHistoryEntry, ChatHistoryUserSummary } from '../types/ai';

const URL = '/v2/admin/chat-history';

class AdminChatHistoryService {
  static getUserSummaries(
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<ChatHistoryUserSummary>> {
    return axios.get(URL, config);
  }

  static getByUserId(
    userId: number,
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<ChatHistoryEntry>> {
    return axios.get(`${URL}/${userId}`, config);
  }
}

export { AdminChatHistoryService };
